export default __webpack_public_path__ + "static/media/ocaze.45c0a9ee.png";